import { CheckStatus, Parse } from '../utils/ajax';

export default {
    getAuditLogs: (parameters, authToken) => (
        fetch(`${manywho.settings.global('platform.uri')}/api/audit/1/search?${parameters}`, {
            headers: {
                Authorization: authToken,
            },
        })
            .then(CheckStatus)
            .then(Parse)),
};
